import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { PreferencesResponse } from "@shared/types/notifications";
import type { UpdatePreferencesInput } from "@shared/validation/notificationPreferences.schema";
import { apiClient, ApiError } from "./client";

const prefsKey = ["notification-preferences"] as const;

/** The effective, fully-populated preference set (every kind present). */
export function useNotificationPreferences() {
  return useQuery<PreferencesResponse, ApiError>({
    queryKey: prefsKey,
    queryFn: () => apiClient<PreferencesResponse>("/api/notification-preferences"),
  });
}

/**
 * Persist per-kind toggles. The PUT response is the full effective set, so we
 * seed the query cache with it — the settings page re-syncs from there.
 */
export function useUpdatePreferences() {
  const queryClient = useQueryClient();
  return useMutation<PreferencesResponse, ApiError, UpdatePreferencesInput>({
    mutationFn: (vars) =>
      apiClient<PreferencesResponse>("/api/notification-preferences", {
        method: "PUT",
        body: JSON.stringify(vars),
      }),
    onSuccess: (data) => {
      queryClient.setQueryData(prefsKey, data);
    },
  });
}
